import { render, staticRenderFns } from "./biddingDetails.vue?vue&type=template&id=8ddcd200&scoped=true&"
import script from "./biddingDetails.vue?vue&type=script&lang=js&"
export * from "./biddingDetails.vue?vue&type=script&lang=js&"
import style0 from "./biddingDetails.vue?vue&type=style&index=0&id=8ddcd200&prod&scoped=true&lang=css&"
import style1 from "./biddingDetails.vue?vue&type=style&index=1&id=8ddcd200&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddcd200",
  null
  
)

export default component.exports